import store from "../store";
import axios from "axios";
import * as https from "https";
import Vue from "vue";
import { getLocation } from "@/utils/location";

const httpsAgent = new https.Agent({
    rejectUnauthorized: false,
});

function corsHeader() {
    return { "Access-Control-Allow-Origin": "*" };
}

function jwtHeader() {
    const token = Vue.$cookies.get("token");
    const storedUser = localStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : "";
    if (user && token && token.value) {
        return { auth: token.value };
    }
    return null;
}

function databaseHeader() {
    return { location: getLocation() };
}

const JWTTokenRequestInterceptor = (config: any) => {
    const currentUrl = String(config && config.url ? config.url : "");
    const isLoggedIn = Boolean(store.getters["Auth/isLoggedIn"]);

    const publicRoute = [
        "auth/login",
        "auth/refreshlogin",
        "user/password/generaterecovery",
        "user/password/changewithtoken",
        "user",
        "produto/all",
        "produto/categorias",
        "produto/imagem",
        "produto/imagem_count",
        "produto/public",
        "public/config",
        "public/config/img/banner_thumb",
        "public/config/img/banner",
        "email/contato"
    ].some((item) => {
        return currentUrl.startsWith(item);
    });

    const jwtHeaders = {} as any;

    config.httpsAgent = httpsAgent;
    if (publicRoute) {
        Object.assign(jwtHeaders, databaseHeader());
    }

    if (isLoggedIn) {
        Object.assign(jwtHeaders, jwtHeader());
    }

    if (jwtHeaders) {
        Object.assign(config.headers, corsHeader());
        Object.assign(config.headers, jwtHeaders);
    }

    return config;
};

let refreshingToken = false;
let failedRequests = [] as Array<any>;

const retryFailedRequests = (error, token = null) => {
    failedRequests.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedRequests = [] as Array<any>;
};

const SessionExpiredInterceptor = (error: any) => {
    if (error?.response?.status == 401 && !String(error?.config?.url).includes("login")) {
        //TODO: fazer logoff na aplicação e tentar direcionar pro home

        const originalRequest = error.config;

        if (!originalRequest._retry) {
            if (refreshingToken) {
                return new Promise(function (resolve, reject) {
                    failedRequests.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers["auth"] = token;
                        return axios(originalRequest);
                    })
                    .catch((err) => {
                        return Promise.reject(err);
                    });
            }

            originalRequest._retry = true;
            refreshingToken = true;

            return new Promise(function (resolve, reject) {
                store
                    .dispatch("Auth/refreshToken", "", { root: true })
                    .then((novoToken) => {
                        originalRequest.headers["auth"] = novoToken;
                        retryFailedRequests(null, novoToken);
                        resolve(axios(originalRequest));
                    })
                    .catch((error) => {
                        retryFailedRequests(error, null);
                        reject(error);
                    })
                    .finally(() => {
                        refreshingToken = false;
                    });
            });
        }

        return Promise.reject(error);
    } else {
        return Promise.reject(error);
    }
};




export { JWTTokenRequestInterceptor, SessionExpiredInterceptor };
